var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2474 4944 c-52 -19 -111 -74 -135 -128 -16 -36 -19 -68 -19 -256 0 -242 6 -266 75 -333 114 -110 300 -77 378 68 21 38 22 54 22 265 0 211 -1 227 -22 265 -60 111 -183 160 -299 119z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975 4321 c-116 -30 -194 -139 -182 -255 3 -30 13 -69 22 -87 10 -19 83 -100 164 -180 127 -127 153 -148 200 -164 137 -45 280 36 312 179 10 44 9 62 -6 112 -16 55 -27 69 -163 207 -81 82 -163 157 -183 167 -42 22 -121 32 -164 21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4017 4316 c-61 -22 -107 -59 -234 -189 -132 -135 -152 -165 -160 -242 -16 -149 117 -281 262 -262 75 11 114 39 266 194 159 160 173 185 172 280 -2 63 -41 143 -90 180 -35 27 -111 53 -152 53 -14 -1 -43 -7 -64 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415 3914 c-259 -40 -429 -103 -625 -232 -103 -68 -275 -238 -347 -343 -100 -147 -181 -334 -219 -509 -26 -119 -27 -419 -1 -538 90 -408 342 -745 697 -931 196 -103 365 -148 580 -158 946 -41 1644 878 1350 1778 -68 207 -172 373 -339 540 -198 198 -396 306 -676 369 -88 20 -349 35 -420 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 2787 c-49 -16 -133 -102 -148 -153 -27 -91 -5 -177 61 -242 66 -65 99 -72 326 -72 238 0 269 8 334 80 114 126 74 308 -83 379 -41 19 -64 20 -250 20 -119 -1 -220 -6 -240 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4320 2787 c-49 -16 -133 -102 -148 -153 -28 -94 -8 -169 63 -239 69 -69 94 -75 327 -75 226 0 263 8 327 72 96 98 95 235 -4 333 -31 32 -65 55 -91 63 -53 15 -424 15 -474 -1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 1489 c-54 -17 -115 -67 -246 -201 -96 -98 -124 -134 -137 -173 -41 -119 6 -239 118 -298 55 -29 155 -29 210 0 22 12 106 88 187 170 136 138 147 152 163 207 21 73 9 143 -35 205 -57 78 -170 117 -260 90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3800 1491 c-82 -27 -149 -92 -170 -167 -17 -59 -7 -135 24 -188 13 -22 87 -103 164 -178 128 -125 145 -138 198 -154 139 -40 277 42 303 182 10 53 1 116 -24 163 -20 38 -294 306 -334 326 -39 19 -125 28 -161 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2479 946 c-57 -20 -106 -64 -134 -119 -24 -50 -25 -55 -25 -266 0 -243 6 -267 75 -334 114 -110 300 -77 378 68 21 38 22 54 22 265 0 211 -1 227 -22 265 -58 108 -184 160 -294 121z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.57501dfa8f6a137a1244180509e1065e.svg";
export { ForwardRef as ReactComponent };